type SizeInput = {
  width: number;
  height: number;
};

export type ImageConfig = {
  smSize: SizeInput;
  mdSize: SizeInput;
  lgSize: SizeInput;
  xlSize: SizeInput;
  fallback: SizeInput;
};

export const defaultImgConfig: ImageConfig = {
  smSize: {
    width: 767,
    height: 857,
  },
  mdSize: {
    width: 1279,
    height: 1166,
  },
  lgSize: {
    width: 1599,
    height: 750,
  },
  xlSize: {
    width: 2560,
    height: 1200,
  },
  fallback: {
    width: 2560,
    height: 1200,
  },
};

export const shopTheLookImgConfig: ImageConfig = {
  smSize: {
    width: 767,
    height: 959,
  },
  mdSize: {
    width: 1279,
    height: 1166,
  },
  lgSize: {
    width: 1599,
    height: 937,
  },
  xlSize: {
    width: 2560,
    height: 1500,
  },
  fallback: {
    width: 2560,
    height: 1500,
  },
};

export const destinationFeatureImgConfig: ImageConfig = {
  smSize: {
    width: 767,
    height: 959,
  },
  mdSize: {
    width: 1280,
    height: 600,
  },
  lgSize: {
    width: 1599,
    height: 750,
  },
  xlSize: {
    width: 2560,
    height: 1200,
  },
  fallback: {
    width: 1599,
    height: 750,
  },
};

export const contentSlot1ImgConfig: ImageConfig = {
  smSize: {
    width: 767,
    height: 959,
  },
  mdSize: {
    width: 1279,
    height: 1279,
  },
  lgSize: {
    width: 640,
    height: 1140,
  },
  xlSize: {
    width: 800,
    height: 1301,
  },
  fallback: {
    width: 801,
    height: 1220,
  },
};

export const contentSlot2ImgConfig: ImageConfig = {
  smSize: {
    width: 768,
    height: 959,
  },
  mdSize: {
    width: 1279,
    height: 1279,
  },
  lgSize: {
    width: 640,
    height: 570,
  },
  xlSize: {
    width: 800,
    height: 650,
  },
  fallback: {
    width: 800,
    height: 650,
  },
};
